'use client';
import { useEffect, useState } from 'react';

export type UseRecaptchaSiteKeyOptions = {
  /** Ne lance le fetch que si vrai (ex. le formulaire exige le captcha). */
  enabled?: boolean | null;
  /** URL de l'endpoint exposant la clé (défaut : /api/recaptcha-config, même origine). */
  configUrl?: string;
};

/**
 * Récupère la clé de site reCAPTCHA AU RUNTIME via l'endpoint Payload
 * `/api/recaptcha-config` (voir `recaptchaPlugin`).
 *
 * On lit la clé via un endpoint plutôt qu'une variable `NEXT_PUBLIC_*` : ces
 * dernières sont gelées au `next build` (en CI, sans le configmap → clé vide).
 *
 * Renvoie `null` tant que la clé n'est pas résolue, puis la chaîne (éventuellement
 * `''` si l'endpoint ne renvoie rien / en cas d'erreur réseau).
 */
export function useRecaptchaSiteKey({
  enabled = true,
  configUrl = '/api/recaptcha-config',
}: UseRecaptchaSiteKeyOptions = {}): string | null {
  const [siteKey, setSiteKey] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let active = true;
    fetch(configUrl)
      .then((res) => res.json())
      .then((data) => {
        if (active) setSiteKey(data?.siteKey ?? '');
      })
      .catch(() => {
        if (active) setSiteKey('');
      });
    return () => {
      active = false;
    };
  }, [enabled, configUrl]);

  return siteKey;
}
